"use strict";
exports.__esModule = true;
exports.notify = void 0;
var index_1 = require("./index");
var notify = function () {
    return index_1.listeners.forEach(function (listener) { return listener(); });
};
exports.notify = notify;
